var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "admin-file-upload" },
    [
      _c("div", { staticClass: "admin-file-upload__toolbar" }, [
        _c(
          "button",
          {
            staticClass:
              "btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline",
            attrs: { type: "button", disabled: _vm.isUploadDisabled },
            on: { click: _vm.launchFilePicker },
          },
          [
            _c("admin-icon", {
              attrs: { name: "upload", "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.buttonText))]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [{ name: "uploader", rawName: "v-uploader" }],
        ref: "file",
        staticClass: "admin-file-upload__native",
        attrs: { type: "file" },
      }),
      _vm._v(" "),
      _c("file-upload-progress", { attrs: { progress: _vm.progress } }),
      _vm._v(" "),
      _vm.progress || _vm.isFileSelected
        ? _c(
            "button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.trans("upload.cancel_upload"),
                  expression: "trans('upload.cancel_upload')",
                },
              ],
              staticClass: "btn btn-sm admin-file-upload__cancel",
              attrs: {
                type: "button",
                "aria-label": _vm.trans("upload.cancel_upload"),
              },
              on: { click: _vm.cancelUpload },
            },
            [
              _c("admin-icon", {
                attrs: { name: "trash", "aria-hidden": "true" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.uploaded_files && _vm.uploaded_files.length
        ? _c(
            "ul",
            { staticClass: "admin-file-upload__list" },
            _vm._l(_vm.uploaded_files, function (uploaded_file) {
              return _c(
                "li",
                {
                  key: uploaded_file.id,
                  staticClass: "admin-file-upload__item",
                },
                [
                  _c(
                    "span",
                    { staticClass: "admin-file-upload__name" },
                    [
                      _c("admin-icon", {
                        attrs: { name: "file", "aria-hidden": "true" },
                      }),
                      _vm._v(
                        "\n              " +
                          _vm._s(uploaded_file.user_filename) +
                          "\n          "
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "confirm",
                          rawName: "v-confirm",
                          value: { ok: _vm.confirmDelete(uploaded_file) },
                          expression: "{ok: confirmDelete(uploaded_file)}",
                        },
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.trans("general.delete_upload"),
                          expression: "trans('general.delete_upload')",
                        },
                      ],
                      staticClass: "admin-file-upload__delete",
                      attrs: {
                        type: "button",
                        "aria-label": _vm.trans("general.delete_upload"),
                      },
                    },
                    [
                      _c("admin-icon", {
                        attrs: { name: "trash", "aria-hidden": "true" },
                      }),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }